module.exports = __webpack_public_path__ + "img/arrow-right-s-fill.67df1fb3.svg";